import React from 'react';

import { Button } from 'ui-components/components/button';
import { Text, TextType } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { bulkHarmonizationMessages } from './messages';
import styles from './styles.module.less';

/**
 * @param {{
 *   highConfidenceCount: number,
 *   onAcceptAll: () => void
 * }} props
 * @returns {React.ReactElement | null}
 */
export const BulkHarmonizationSummaryBanner = ({ highConfidenceCount, onAcceptAll }) => {
  if (highConfidenceCount === 0) {
    return null;
  }

  return (
    <div className={styles.summaryBanner}>
      <Text
        formattedMessageValues={{ count: highConfidenceCount }}
        textType={TextType.Paragraph}
        value={bulkHarmonizationMessages.highConfidenceSummary}
      />
      <Button onClick={onAcceptAll} theme={THEME_CONSTANTS.secondary}>
        <Text value={bulkHarmonizationMessages.acceptAllHighConfidence} />
      </Button>
    </div>
  );
};
